// two bobby: slim cart bar (see snippets/tb-cart-bar.liquid). Loaded on every page from snippets/cart-drawer.liquid, because
// the snippet itself only renders when the cart has items: a {% javascript %} block there was missing when a shopper
// started with an empty cart (18 Oct 2026 bug: no Check out on phones after the first add).
if (!customElements.get('tb-cart-bar')) {
  class TbCartBar extends HTMLElement {
    connectedCallback() {
      this.drawer = this.closest('dialog');
      this.check = this.check.bind(this);
      this.queue = () => {
        if (this.timer) return;
        this.timer = setTimeout(() => {
          this.timer = 0;
          this.check();
        }, 60);
      };
      document.addEventListener('scroll', this.queue, true);
      window.addEventListener('resize', this.queue);
      document.addEventListener('cart:update', this.queue);
      this.observer = new MutationObserver(this.queue);
      // also watch the real Check out button itself, so the bar updates even where scroll events are not delivered
      this.io = 'IntersectionObserver' in window ? new IntersectionObserver(this.queue, {threshold: [0, 0.5, 1]}) : null;
      if (this.drawer) this.observer.observe(this.drawer, { attributes: true, attributeFilter: ['open', 'hidden'], childList: true, subtree: true });
      this.queue();
    }

    disconnectedCallback() {
      document.removeEventListener('scroll', this.queue, true);
      window.removeEventListener('resize', this.queue);
      document.removeEventListener('cart:update', this.queue);
      if (this.observer) this.observer.disconnect();
      if (this.io) this.io.disconnect();
    }

    check() {
      const open = this.drawer && this.drawer.hasAttribute('open');
      const real = this.drawer && this.drawer.querySelector('.cart-drawer__summary [name="checkout"]');
      // 28 Oct 2026 (Gunjan): the bar's "₹X to free prepaid shipping" line repeated the cart's progress box while both were
      // on screen; it now shows only once the progress box has scrolled out of view
      const progress = this.drawer && this.drawer.querySelector('.tb-ship');
      if (this.io && (real !== this.watched || progress !== this.watchedProgress)) {
        this.io.disconnect();
        if (real) this.io.observe(real);
        if (progress) this.io.observe(progress);
        this.watched = real;
        this.watchedProgress = progress;
      }
      // 18 Oct 2026 (founders): on phones the bar is ALWAYS shown while the drawer is open (Check out stuck to the
      // bottom); the summary's own Check out button is hidden on phones (cart-summary.liquid), so it never shows twice.
      const show = !!(open && real);
      if (this.hidden === show) this.hidden = !show;
      let progressInView = false;
      if (show && progress) {
        const r = progress.getBoundingClientRect();
        const top = this.drawer.getBoundingClientRect().top;
        const barTop = this.getBoundingClientRect().top;
        progressInView = r.height > 0 && r.bottom > top && r.top < barTop;
      }
      this.classList.toggle('tb-cart-bar--quiet', progressInView);
    }
  }
  customElements.define('tb-cart-bar', TbCartBar);
}
